import { BrowserRouter } from 'react-router-dom';
import { createRoot } from "react-dom/client";

import React from 'react';

import Root from './Root';

import "react-toggle-switch/dist/css/switch.min.css"

const root = createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter>
        <Root />
    </BrowserRouter>
);



// WEBPACK FOOTER //
// ./src/index.js